import React, { useState } from 'react';
import { Tabs, Tab, Box, Typography, Paper, Fade } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import ReceiptIcon from '@mui/icons-material/Receipt';
import DescriptionIcon from '@mui/icons-material/Description';
import Vendor from './ocrVendor';
import PurchaseOrders from './ocrPurchaseOrders';
import GRNs from './OcrGRNs';
import Invoices from './OcrInvoices';

function OCRProcesses() {
  const [activeComponent, setActiveComponent] = useState('vendor');
  const [isVendorSelected, setIsVendorSelected] = useState(false);
  const [isPurchaseOrderSelected, setIsPurchaseOrderSelected] = useState(false);
  const [isGRNSelected, setIsGRNSelected] = useState(false);

  return (
    <Box sx={{ padding: '20px', minHeight: '100vh' }}>
      <Typography
        variant="h4"
        sx={{ marginBottom: '20px', fontWeight: 'bold', color: '#1976d2' }}
      >
        OCR Processes
      </Typography>
      <Tabs
        value={activeComponent}
        onChange={(e, newValue) => setActiveComponent(newValue)}
        sx={{ marginBottom: '20px' }}
      >
        <Tab icon={<BusinessIcon />} label="Vendor" value="vendor" />
        <Tab
          icon={<ShoppingCartIcon />}
          label="Purchase Orders"
          value="purchaseOrders"
          disabled={!isVendorSelected}
        />
        <Tab
          icon={<ReceiptIcon />}
          label="GRNs"
          value="grns"
          disabled={!isPurchaseOrderSelected}
        />
        <Tab
          icon={<DescriptionIcon />}
          label="Invoices"
          value="invoices"
          disabled={!isGRNSelected}
        />
      </Tabs>
      <Paper
        sx={{
          padding: '20px',
          borderRadius: '8px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      >
        {activeComponent === 'vendor' && (
          <Fade in={activeComponent === 'vendor'} timeout={300}>
            <div>
              <Vendor
                onCheckboxSelection={(selected) => setIsVendorSelected(selected)}
              />
            </div>
          </Fade>
        )}
        {activeComponent === 'purchaseOrders' && (
          <Fade in={activeComponent === 'purchaseOrders'} timeout={300}>
            <div>
              <PurchaseOrders
                onCheckboxSelection={(selected) =>
                  setIsPurchaseOrderSelected(selected)
                }
              />
            </div>
          </Fade>
        )}
        {activeComponent === 'grns' && (
          <Fade in={activeComponent === 'grns'} timeout={300}>
            <div>
              <GRNs
                onCheckboxSelection={(selected) => setIsGRNSelected(selected)}
              />
            </div>
          </Fade>
        )}
        {activeComponent === 'invoices' && (
          <Fade in={activeComponent === 'invoices'} timeout={300}>
            <div>
              <Invoices />
            </div>
          </Fade>
        )}
      </Paper>
    </Box>
  );
}

export default OCRProcesses;